import $ from 'jquery'
import Flickity from 'flickity'
import { fixMobileSwipe } from './patches/FlickityPatch'

export default () => {
    $(window).on('resize', () => {
        initNewsSlider()
    }).resize()
}

function initNewsSlider () {

    let $sliderElement = $('body .news .news-holder')
    let slide = $sliderElement.find('.holder')

    let options = {
        cellSelector: '.holder',
        pageDots: false,
        contain: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        autoPlay: false,
        wrapAround: false,
        cellAlign: 'center',
        groupCells: false,
        draggable: '>1',
        imagesLoaded: true,
        watchCSS: true,
    }

    if (slide.length <= 0) {
        return
    }

    let flkty = new Flickity($sliderElement.get(0), options)

    fixMobileSwipe($sliderElement)
}
